import React, { useEffect, useRef, useState } from 'react';
import { TMobileNavigationBarProps } from '../../../types/PrivacyStatement.types';
import { documentService, windowService } from '../../../../../utils/window.utils.js';
import { detectScrollDirectionForNavigationBar } from '../../../../../utils/detectScrollDirectionForNavigationBar.utils';
import useStickyWrapper from '../../../../../hooks/useStickyWrapper';
import { createPortal } from 'react-dom';

const NavigationBar = (props: TMobileNavigationBarProps) => {
    const { privacyContentItems } = props;
    const navigationBarHeight = 60;
    const parentContainerTopPadding = 40;
    const [activeItem, setActiveItem] = useState<number>(0);
    const stickyWrapperEle = useStickyWrapper();
    const [isFromClick, setIsFromClick] = useState(false);
    const isFromClickRef = useRef<boolean>();
    isFromClickRef.current = isFromClick;
    let scrollPosition = 0;

    const detectActiveTab = () => {
        const contentTabs = documentService()?.querySelectorAll('.privacy-statement-v2__content-tab');
        if (!contentTabs) return;
        const sectionHighlightTabHeight = windowService().innerHeight / 4;

        // if at least the first element is not in the highlighted section set the active tab to first
        if (contentTabs.item(0)?.getBoundingClientRect()?.top > sectionHighlightTabHeight) {
            setActiveItem(0);
            return;
        }

        let _activeTab = 0;
        for (let i = 0; i < contentTabs.length; i++) {
            if (contentTabs?.item(i)?.getBoundingClientRect().top < sectionHighlightTabHeight) {
                _activeTab = i;
            } else {
                break;
            }
        }
        setActiveItem(_activeTab);
    };

    const scrollEventListner = () => {
        scrollPosition = detectScrollDirectionForNavigationBar(stickyWrapperEle, scrollPosition);
        if (isFromClickRef.current) {
            setIsFromClick(false);
            return;
        }
        detectActiveTab();
    };

    useEffect(() => {
        scrollPosition = detectScrollDirectionForNavigationBar(stickyWrapperEle, scrollPosition);
    });

    useEffect(() => {
        documentService()?.querySelector('.sticky-top-wrapper .active')?.scrollIntoView();
        documentService()?.querySelector('.active')?.scrollIntoView();
    }, [isFromClick, activeItem]);

    useEffect(() => {
        windowService()?.addEventListener('scroll', scrollEventListner, false);
        return () => {
            windowService()?.removeEventListener('scroll', scrollEventListner);
        };
    }, [stickyWrapperEle]); // eslint-disable-line

    const scrollItem = (id: string) => {
        const ele = documentService()?.getElementById(`${id}`);
        if (ele) {
            windowService()?.scrollTo(0, ele.offsetTop - parentContainerTopPadding - navigationBarHeight);
        }
    };

    const NavigationTabs = ({sticky = false}) => {
        return (
            <div className={`privacy-statement-v2-mobile__navbar ${sticky ? 'sticky-element--hide' : ''}`}>
                {privacyContentItems.map((item, index) => {
                    return (
                        <span
                            className={`privacy-statement-v2-mobile__navbar-label ${activeItem === index ? 'active' : ''}`}
                            onClick={() => {
                                scrollItem(item.id);
                                setIsFromClick(true);
                                setActiveItem(index);
                            }}
                        >
                            {item?.fields?.anchorContentTitle?.value}
                        </span>
                    )
                })}
            </div>
        )
    }


    return (
        <>
            <NavigationTabs/>
            {
                stickyWrapperEle &&
                createPortal(<NavigationTabs sticky={true} />, stickyWrapperEle)
            }
        </>

    )
}

export default NavigationBar;
